var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"module-state-box"},[(_setup.displayLoading)?[(_setup.useSkeleton)?_c(_setup.VanSkeleton,{attrs:{"row":3,"row-width":['100%', '100%', '100%']}}):_c('div',{staticClass:"module-state-loading"})]:(_vm.empty)?_c(_setup.CFullEmpty):_c('div',{staticClass:"module-state-content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }